export const styles = {
  container: {
    paddingTop: '2em',
  },
  tableContainer: {
    marginTop: '1em',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  tableHeader: {
    fontWeight: 'bold',
  },
  button: {
    marginRight: '1em',
    fontSize: '1rem',
    borderRadius: '2em',
    padding: '0.5em 2em',
    textTransform: 'none',
  },
  chip: {
    borderRadius: '1em',
    '& .MuiChip-label': {
      padding: '0.5em 1em',
    },
  },
  published: {
    backgroundColor: '#4caf50',
    color: 'white',
  },
  unpublished: {
    backgroundColor: '#ff9800',
    color: 'white',
  },
  actionButton: {
    minWidth: '100px',
    textTransform: 'none',
  },
};